export default __webpack_public_path__ + "static/media/maxcdn.39cbf36d.svg";